export default function generateStatistics(state = {}, action) {
  switch (action.type) {
    case "GENERATE_STATISTICS":
      return {
        stats: action.stats
      };
    default:
      return state
  }
}